import {Component, Reactive, VNode} from "vue";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {RadioGroupChildOption} from "ant-design-vue/es/radio/Group";
import {ICouponPolicy, IInput, INotice, IProduct} from "@/views/editor/service/types";

export interface INewBusiness {
    new(editor: AEditor, meta: IActivityBusinessMeta): IBusiness;
}

export interface IBusiness {
    readonly icon: () => VNode;
    readonly title: string;
    readonly description: string;
    readonly meta: IActivityBusinessMeta
    readonly preview?: string;

    destructor(): void

    implementations(status: EActivityStatus): RadioGroupChildOption[];

    subs(status: EActivityStatus): CheckboxOptionType[];

    /**
     * 新创建活动时初始化业务
     * @param {EActivityStatus} status - 活动状态。
     * @return {IBusiness} 对象自己。
     */
    resetMeta(status: EActivityStatus): IBusiness

    apply(): IBusiness
}

export interface IBizAtmosphere extends IBusiness {
    setRules(owner: string, rules: INotice[]): void

    getBaseController(): Component
}

export interface IBizPromotion extends IBusiness {
    products(): IProduct[]

    price(): number

    lookersListView(): { title: string, component: Component }

    skuDisplay(): Component
}

export type IBizChallenge = IBusiness
export type IBizRaffle = IBusiness
// export interface IBizRaffle extends IBusiness {
//     setPrizes(owner: string, prizes: unknown[]): void
// }

export interface IBizCoupon extends IBusiness {
    setPolicies(owner: string, policies: ICouponPolicy[]): void
}

export interface IBizProfitSharing extends IBusiness {
    readonly active: Reactive<{ rate: { distribution: number, employee: number, cash_back: number, all: number } }>

    clearRate(): void

    shareRate(): number
}

export type IBizRedEnvelope = IBusiness


export interface IBizSign extends IBusiness {
    set(owner: string, inputs: IInput[]): void

    setButtonText(text: string): void

    getButtonText(): string
}

export interface IBiz {
    atmosphere: IBizAtmosphere | undefined
    promotion: IBizPromotion | undefined
    challenge: IBizChallenge | undefined
    raffle: IBizRaffle | undefined
    coupon: IBizCoupon | undefined
    profit_sharing: IBizProfitSharing | undefined
    red_envelope: IBizRedEnvelope | undefined
    sign: IBizSign | undefined
}

export const emptyBiz = (): IBiz => ({
    atmosphere: undefined,
    challenge: undefined,
    coupon: undefined,
    profit_sharing: undefined,
    promotion: undefined,
    raffle: undefined,
    red_envelope: undefined,
    sign: undefined
})

export abstract class ABusiness implements IBusiness {

    abstract icon(): VNode;

    readonly abstract title: string;
    readonly abstract description: string;

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
    }

    destructor(): void {
        //
    }

    abstract subs(status: EActivityStatus): CheckboxOptionType[];

    abstract implementations(status: EActivityStatus): RadioGroupChildOption[];

    abstract resetMeta(status: EActivityStatus): IBusiness

    apply(): IBusiness {
        return this
    }
}